module.exports = __webpack_public_path__ + "img/SMB供應商、SI與終端使用者的關係流程.a53f96a8.png";